module.exports = __webpack_public_path__ + "img/nv1500covid.db7c2904.png";